module.exports = __webpack_public_path__ + "img/st_lazarus_district.c5ccd877.jpg";